"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const formik_1 = require("formik");
const form_1 = require("../lib/form");
const validation_1 = require("../lib/validation");
const field_group_1 = __importDefault(require("./form/field-group"));
const toggle_group_1 = __importDefault(require("./form/toggle-group"));
const fields_1 = require("./form/fields");
const layout_1 = __importDefault(require("./form/layout"));
const success_1 = __importDefault(require("./form/success"));
const label_1 = __importDefault(require("./form/label"));
const initialValues = {
    name: '',
    company: '',
    role: '',
    email: '',
    optIn: false,
};
function DownloadForm({ id }) {
    const handleSubmit = (0, form_1.getSubmitHandler)('/wp-json/compleat/v1/carbon-labelling', initialValues, (values) => {
        return Object.assign({ pageId: Number(id) }, values);
    });
    return ((0, preact_1.h)(formik_1.Formik, { initialValues: initialValues, initialStatus: false, validate: validate, onSubmit: handleSubmit },
        (0, preact_1.h)(formik_1.Form, { noValidate: true },
            (0, preact_1.h)(DownloadFormFields, null))));
}
exports.default = DownloadForm;
function DownloadFormFields() {
    const { isSubmitting, status: isSubmitted } = (0, formik_1.useFormikContext)();
    const hideForm = isSubmitting || isSubmitted;
    return ((0, preact_1.h)(layout_1.default, null,
        (0, preact_1.h)(layout_1.default.Fields, null,
            (0, preact_1.h)("div", { className: `grid sm:grid-cols-2 gap-x-7 gap-y-5` },
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)(label_1.default, { htmlFor: 'download.name', required: true }, "Your name"),
                    (0, preact_1.h)(field_group_1.default, null,
                        (0, preact_1.h)(fields_1.TextField, { type: 'text', name: 'name', id: 'download.name', size: 1, required: true, disabled: hideForm }),
                        (0, preact_1.h)(field_group_1.default.Status, { name: 'name' }))),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)(label_1.default, { htmlFor: 'download.company', required: true }, "Company name"),
                    (0, preact_1.h)(field_group_1.default, null,
                        (0, preact_1.h)(fields_1.TextField, { type: 'text', name: 'company', id: 'download.company', size: 1, required: true, disabled: hideForm }),
                        (0, preact_1.h)(field_group_1.default.Status, { name: 'company' }))),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)(label_1.default, { htmlFor: 'download.role', required: true }, "Role"),
                    (0, preact_1.h)(field_group_1.default, null,
                        (0, preact_1.h)(fields_1.TextField, { type: 'text', name: 'role', id: 'download.role', size: 1, required: true, disabled: hideForm }),
                        (0, preact_1.h)(field_group_1.default.Status, { name: 'role' }))),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)(label_1.default, { htmlFor: 'download.email', required: true }, "Email address"),
                    (0, preact_1.h)(field_group_1.default, null,
                        (0, preact_1.h)(fields_1.TextField, { type: 'email', name: 'email', id: 'download.email', size: 1, required: true, disabled: hideForm }),
                        (0, preact_1.h)(field_group_1.default.Status, { name: 'email' }))),
                (0, preact_1.h)("div", { className: 'sm:col-span-2' },
                    (0, preact_1.h)(toggle_group_1.default, null,
                        (0, preact_1.h)(toggle_group_1.default.Input, null,
                            (0, preact_1.h)(fields_1.CheckboxField, { name: 'optIn', id: 'download.optIn' })),
                        (0, preact_1.h)(toggle_group_1.default.Label, { htmlFor: 'download.optIn' }, "Please tick this box if you are happy for us to share your data with our partners to be the first in the know for future papers and industry events.")))),
            (0, preact_1.h)("div", { className: 'mt-8 md:mt-10 text-center' },
                (0, preact_1.h)("button", { type: 'submit', disabled: hideForm, className: 'block sm:inline-block w-full sm:w-52 border-2 border-teal text-teal py-4 px-6 font-heading text-lg sm:text-xl leading-none uppercase transition-colors hover:bg-teal hover:text-white' }, isSubmitting ? 'Please wait…' : 'Submit'))),
        (0, preact_1.h)("div", { "aria-live": 'polite' },
            (0, preact_1.h)(success_1.default, null,
                (0, preact_1.h)(success_1.default.Heading, null, "Thank you"),
                (0, preact_1.h)(success_1.default.Content, null,
                    (0, preact_1.h)("p", null, "A copy of the white paper will now be in your inbox."),
                    (0, preact_1.h)("p", null,
                        "We will be working with the ",
                        (0, preact_1.h)("a", { href: 'https://futurefoodmovement.com/', target: '_blank', rel: 'noopener noreferrer' }, "Future Food Movement"),
                        " on an event in September to discuss the key points of our findings, ",
                        (0, preact_1.h)("a", { href: 'https://futurefoodmovement.com/how-do-we-engage-consumers-on-climate/', target: '_blank', rel: 'noopener noreferrer' }, "please join us and sign up here"),
                        "."))))));
}
function validate(values) {
    let errors = {};
    if (values.name === '') {
        errors = (0, formik_1.setIn)(errors, 'name', 'Please enter your name');
    }
    if (values.company === '') {
        errors = (0, formik_1.setIn)(errors, 'company', 'Please enter your company name');
    }
    if (values.role === '') {
        errors = (0, formik_1.setIn)(errors, 'role', 'Please enter your role');
    }
    if (values.email === '') {
        errors = (0, formik_1.setIn)(errors, 'email', 'Please enter your email address');
    }
    else if (!(0, validation_1.isValidEmail)(values.email)) {
        errors = (0, formik_1.setIn)(errors, 'email', 'Please enter a valid email address');
    }
    return errors;
}
